import { ContainerType } from '@routable/tablematic';
import { DiscountBlock, TotalsPanel, TotalsPanelStandaloneTotal } from 'modules/table/components';
export const containerComponents = {
    [ContainerType.discount]: DiscountBlock,
    [ContainerType.totals]: TotalsPanelStandaloneTotal,
    [ContainerType.totals_standalone]: TotalsPanel,
};
